module.exports = __webpack_public_path__ + "img/0037.3ca7c356.jpg";